import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'

export const getMetricas = async (codLocal: string, tenant: ITenant, detallado: boolean) => {
  let url = `${tenant.path}/metricas/local/${codLocal}`
  if (detallado) url += `?detallado=${detallado}`

  return await axiosInstanceMain.get(url)
}

export const getProductosMasVistos = async (
  tenant: ITenant,
  periodo: string,
  miLocal: boolean,
  codRubro: string,
  limit: number
) => {
  let url = `/${tenant.path}/metricas/productos-mas-visitados?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  miLocal && params.push(`mi-local=${miLocal}`)
  codRubro && params.push(`codRubro=${codRubro}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getProductosFav = async (
  tenant: ITenant,
  periodo: string,
  miLocal: boolean,
  codRubro: string,
  limit: number
) => {
  let url = `/${tenant.path}/metricas/productos-mas-favoriteados?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  miLocal && params.push(`mi-local=${miLocal}`)
  codRubro && params.push(`codRubro=${codRubro}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getProductosContactados = async (
  tenant: ITenant,
  periodo: string,
  miLocal: boolean,
  codRubro: string,
  limit: number
) => {
  let url = `/${tenant.path}/metricas/productos-mas-contactados?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  miLocal && params.push(`mi-local=${miLocal}`)
  codRubro && params.push(`codRubro=${codRubro}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getRubrosMasVistos = async (tenant: ITenant, periodo: string, limit: number) => {
  let url = `/${tenant.path}/metricas/rubros-mas-visitados?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getLocalesContactados = async (tenant: ITenant, periodo: string, limit: number) => {
  let url = `/${tenant.path}/metricas/locales-mas-contactados?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getLocalesSeguidos = async (tenant: ITenant, periodo: string, limit: number) => {
  let url = `/${tenant.path}/metricas/locales-mas-seguidos?`
  const params: string[] = []
  periodo && params.push(`periodo=${periodo}`)
  limit && params.push(`limit=${limit}`)

  url += params.join('&')
  return await axiosInstanceMain.get(url)
}

export const getBusquedasCluster = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`/${tenant.path}/metricas/busquedas-clusterizadas`)

export const getRubrosMetricas = async (tenant: ITenant, codLocal: string) =>
  await axiosInstanceMain.get(`/${tenant.path}/locales/${codLocal}/rubros-nombre`)
